export default __webpack_public_path__ + "static/media/alphastar-academy-logo.4404c797.svg";